import { useIsMutating } from "@tanstack/react-query";
import { LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { CheckIcon, RedoIcon, SlidersIcon, UndoIcon } from "../../../components/restaurant-schema/schemaIcons";

const HISTORY_BUTTON =
  "flex h-[34px] w-[34px] cursor-pointer items-center justify-center rounded-[7px] border-none bg-transparent text-ink-2 transition-colors duration-150 hover:bg-fill disabled:cursor-not-allowed disabled:text-faint disabled:hover:bg-transparent";

/**
 * Дясната половина на лентата (дизайн, т. 2): Отмени/Повтори, индикаторът
 * „Запазено" (докато има заявка в полет — „Запазва се…") и „Редакция на
 * регион". На тесен екран остават само иконите.
 */
const EditorToolbar = ({
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  onOpenSettings,
}: {
  canUndo: boolean;
  canRedo: boolean;
  onUndo: () => void;
  onRedo: () => void;
  onOpenSettings: () => void;
}) => {
  const { t } = useTranslation();
  // На страницата няма други мутации освен тези на схемата.
  const isSaving = useIsMutating() > 0;

  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-0.5 rounded-[10px] border border-shade-2 bg-surface p-[3px]">
        <button
          type="button"
          title={t("restaurantSchema.toolbar.undo")}
          aria-label={t("restaurantSchema.toolbar.undo")}
          disabled={!canUndo}
          onClick={onUndo}
          className={HISTORY_BUTTON}
        >
          <UndoIcon className="h-[17px] w-[17px]" />
        </button>
        <button
          type="button"
          title={t("restaurantSchema.toolbar.redo")}
          aria-label={t("restaurantSchema.toolbar.redo")}
          disabled={!canRedo}
          onClick={onRedo}
          className={HISTORY_BUTTON}
        >
          <RedoIcon className="h-[17px] w-[17px]" />
        </button>
      </div>
      <div className="flex items-center gap-1.5 whitespace-nowrap text-[12.5px] font-medium text-body">
        {isSaving ? (
          <LoadingOutlined className="text-[13px] text-muted" />
        ) : (
          <CheckIcon className="h-[15px] w-[15px] text-ok" />
        )}
        <span className="hidden sm:inline">
          {isSaving ? t("restaurantSchema.toolbar.saving") : t("restaurantSchema.toolbar.saved")}
        </span>
      </div>
      <span className="h-7 w-px bg-shade-3" />
      <button
        type="button"
        onClick={onOpenSettings}
        title={t("restaurantSchema.regionSettings.button")}
        className="flex h-[42px] cursor-pointer items-center gap-2 whitespace-nowrap rounded-[10px] border border-shade-3 bg-surface px-3.5 text-[13.5px] font-semibold text-ink transition-colors duration-150 hover:bg-panel"
      >
        <SlidersIcon className="h-4 w-4" />
        <span className="hidden sm:inline">{t("restaurantSchema.regionSettings.button")}</span>
      </button>
    </div>
  );
};

export default EditorToolbar;
